<script setup lang="ts">
import type { RadioProps } from "./radio.types";
import { useRadio } from "./useRadio";
import { radioIndicatorWrapperClasses, radioEncasedWrapperClasses } from "./radio.styles";

defineOptions({ name: "ERadio" });

const props = withDefaults(defineProps<RadioProps>(), {
  disabled: false,
  required: false,
  icon: "circle",
  encased: false,
});

const {
  state,
  rootClasses,
  buttonClasses,
  ariaChecked,
  ariaDisabled,
  dataDisabled,
  dataState,
  handleClick,
  indicatorIcon,
  indicatorClasses,
  tabIndex,
  handleKeyDown,
  buttonRef,
  WrapperComponent,
} = useRadio({ props });

defineExpose({ buttonRef });
</script>

<template>
  <component
    :is="WrapperComponent"
    :color="state.encased?.value ? state.color?.value : undefined"
    :variant="state.encased?.value ? state.variant?.value : undefined"
    :size="state.encased?.value ? 'sm' : undefined"
    :class="state.encased?.value ? radioEncasedWrapperClasses : undefined"
  >
    <div part="base" exportparts="indicator-icon" :class="rootClasses" @click="handleClick">
      <button
        ref="buttonRef"
        type="button"
        role="radio"
        part="control"
        :tabindex="tabIndex"
        :class="buttonClasses"
        :aria-checked="ariaChecked"
        :aria-disabled="ariaDisabled"
        :data-disabled="dataDisabled"
        :data-state="dataState"
        @keydown="handleKeyDown"
      >
        <span part="indicator" :class="radioIndicatorWrapperClasses">
          <e-icon exportparts="base:indicator-icon" :class="indicatorClasses" :name="indicatorIcon" />
        </span>
      </button>

      <slot />
    </div>
  </component>
</template>

<style>
:host {
  min-width: 0;
}
</style>
